import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TaxidTypeDisplayComponent } from '../taxid-type-display/taxid-type-display.component';
import { AdditionalTaxInfoValue, FieldPermission, TaxCountryConfig, TaxIdTypeInfo } from 'app/profile/models/tax.model';
import { I18nService } from 'app/shared/services/i18n.service';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MaskedFieldControl } from 'app/common/models/masked-field.model';
import { isNotNullOrUndefined, isNullOrEmpty, isNullOrUndefined, validateAllFormFields } from 'app/shared/utils/utils';
import * as _ from 'lodash';

@Component({
  selector: 'app-taxid-type-display-child',
  templateUrl: './taxid-type-display-child.component.html',
  styleUrls: ['./taxid-type-display-child.component.scss']
})
export class TaxidTypeDisplayChildComponent implements OnInit, OnChanges {

  // Declare Variables
  public parentTaxIdTypeComponent : TaxidTypeDisplayComponent;

  // Input Component Variables
  public TaxIdList: TaxIdTypeInfo[];
  public canChildBeDeleted: boolean;
  public currentComponentIndex: number;
  public currentSelectedCountry : TaxCountryConfig;
  public isValidationSkipped: boolean = false;
  public taxIdData: AdditionalTaxInfoValue;
  public permission:string = null;
  public isFieldDisabled : boolean = true;
  public isVisibility : boolean = false;

  // Component Variables
  public isDeleteAvailable: boolean = false;
  public isFormDisabled: boolean = false;

  // Form Related Variables
  public taxIdTypeChildForm : FormGroup;
  public TaxIdTypeName: FormControl;
  public TaxIdTypeValue: MaskedFieldControl;
  public TaxIdTypeReadValue: FormControl;

  constructor(
    private translate: I18nService,
    private formBuilder: FormBuilder
  ) { 

    // Initialize Form Variables
    this.TaxIdTypeName = new FormControl(null ,(this.isValidationSkipped == false) ? Validators.required : null);
    this.TaxIdTypeValue = new MaskedFieldControl(null, null);
    this.TaxIdTypeReadValue = new FormControl(null);
    this.taxIdTypeChildForm = this.formBuilder.group(
      {
        TaxIdTypeName : this.TaxIdTypeName,
        TaxIdTypeValue : this.TaxIdTypeValue.fieldControl,
        TaxIdTypeReadValue : this.TaxIdTypeReadValue
      }
    );
  }

  ngOnChanges(changes : SimpleChanges): void {

    if(changes.taxIdData)
    {
      if(_.isEqual(changes.taxIdData.currentValue, changes.taxIdData.previousValue) == false)
      {
        this.setData(changes.taxIdData.currentValue);
      }
    }

  }

  ngOnInit(): void {
    this.isDeleteOptionAvailable();

    this.TaxIdTypeName.valueChanges.subscribe(value => {this.isFormDisabledFunc(value) ; this.onTaxIdTypeChange(value); this.parentTaxIdTypeComponent.updateExceptionList(true)});

    if(this.canChildBeDeleted == false && this.permission?.toLowerCase() == FieldPermission.ReadWrite)
    {
      this.TaxIdTypeName.setValue(this.TaxIdList[0]?.taxIdType, { emitEvent: true });
    }

    if(!isNullOrUndefined(this.taxIdData))
    {
      this.setData(this.taxIdData);
    }

    // Set Field 
    this.isFieldDisabled = !isNullOrUndefined(this.permission) && this.permission?.toLowerCase() === FieldPermission.ReadWrite ? false : true;
    
    if(this.isFieldDisabled == true)
    {
      this.TaxIdTypeReadValue.setValue('****' + this.taxIdData?.last4TaxIdValue);
    }
  }

  isDeleteOptionAvailable()
  {
    if(this.canChildBeDeleted == false)
    {
      this.isDeleteAvailable = false;
    }

    if(this.canChildBeDeleted == true && this.parentTaxIdTypeComponent.componentsReferences?.length > 1)
    {
      this.isDeleteAvailable = true;
    }
    else
    {
      this.isDeleteAvailable = false;
    }
  }

  deleteCurrentComponent()
  {
    // Call the DeleteComponent func in parent component
    this.parentTaxIdTypeComponent.deleteComponent(this.currentComponentIndex);
  }

  // If User selects an option than the current form should be disabled
  isFormDisabledFunc(value: string)
  {
    if(!isNullOrUndefined(this.taxIdTypeChildForm.get('TaxIdTypeName')?.value))
    {
      if(this.parentTaxIdTypeComponent?.componentsReferences?.length > 0)
      {
        // Set IsFormDisabled so user can not edit it again
        this.isFormDisabled = true;
      }
      else
      {
        this.isFormDisabled = false;
      }

      // Update Parent Component 
      this.parentTaxIdTypeComponent.exceptionTaxIdTypes.push(this.TaxIdList.filter(x => x.taxIdType == value)[0]);
      this.parentTaxIdTypeComponent.isAddButtonRequired();
    }
    else
    {
      this.isFormDisabled = false;
    }
  }

  onTaxIdTypeChange(taxIdType: string) 
  {

    // Set Validation Required as true
    // If Regex Pattern is Not Empty Set Regex Pattern Validation
    // If selectedCountry has blocked list than add blocked list validator
    // this.taxIdControl.fieldControl.updateValueAndValidity({ emitEvent: false });
    var currentTaxIdTypeInfo = this.TaxIdList.filter(x => x.taxIdType == taxIdType)[0];
    var validatorList = [];
    var taxIdTypeValidatorList = [];

    if(!isNullOrUndefined(currentTaxIdTypeInfo))
    {
      if(currentTaxIdTypeInfo.taxIdTypeValidationInfo?.isRequired == true)
      {
        validatorList.push(Validators.required);
      }

      if(currentTaxIdTypeInfo.taxIdTypeValidationInfo?.isRequired == false)
      {
        taxIdTypeValidatorList.push(Validators.required);
      }

      if(!isNullOrUndefined(currentTaxIdTypeInfo?.taxIdTypeValidationInfo?.regexFormatPattern) && !isNullOrEmpty(currentTaxIdTypeInfo?.taxIdTypeValidationInfo?.regexFormatPattern))
      {
        validatorList.push(Validators.pattern(currentTaxIdTypeInfo?.taxIdTypeValidationInfo?.regexFormatPattern));
      }

      if(!isNullOrUndefined(currentTaxIdTypeInfo?.taxIdTypeValidationInfo?.minLength) && currentTaxIdTypeInfo?.taxIdTypeValidationInfo?.minLength > 0 )
      {
        validatorList.push(Validators.minLength(currentTaxIdTypeInfo?.taxIdTypeValidationInfo?.minLength))
      }

      if(!isNullOrUndefined(currentTaxIdTypeInfo?.taxIdTypeValidationInfo?.maxLength) && currentTaxIdTypeInfo?.taxIdTypeValidationInfo?.maxLength > 0 )
      {
        validatorList.push(Validators.maxLength(currentTaxIdTypeInfo?.taxIdTypeValidationInfo?.maxLength))
      }

      if(currentTaxIdTypeInfo.taxIdTypeValidationInfo?.isBlockedListValidationRequired == true)
      {
          if(!isNullOrUndefined(currentTaxIdTypeInfo?.taxIdTypeValidationInfo.blockListValidationPattern))
          {
              validatorList.push(this.blockListValidator(currentTaxIdTypeInfo?.taxIdTypeValidationInfo.blockListValidationPattern));
          }
      }

      if(validatorList.length > 0)
      {
        this.TaxIdTypeValue.fieldControl.clearValidators();
        this.TaxIdTypeValue.fieldControl.setValidators(validatorList);
      }

      // If Tax Id Type selected and not required to push in the change then Add the validators
      if(taxIdTypeValidatorList.length > 0)
      {
        this.TaxIdTypeName.clearValidators();
        this.TaxIdTypeName.setValidators(taxIdTypeValidatorList);
      }
    }
  }

  getValidationErrorMessages(displayName: string, control: FormControl)
  {
    if(control.dirty || control.touched)
    {
      // Get Current Value 
      var currentTaxIdType = this.TaxIdTypeName?.value;
      var currentTaxIdtypeInfo = this.TaxIdList.filter(x => x.taxIdType == currentTaxIdType)[0];

      if(control.hasError('required'))
      {
        return this.translate.get(displayName) + ' ' + this.translate.get('is required');
      }

      if(!isNullOrUndefined(currentTaxIdtypeInfo))
      {
        if(control.hasError('blockedNumber'))
        {
          return this.translate.get(currentTaxIdtypeInfo.taxIdTypeValidationInfo?.errorMessage?.blockedListError);
        }

        if(control.hasError('blockedNumber'))
        {
          return this.translate.get(currentTaxIdtypeInfo.taxIdTypeValidationInfo?.errorMessage?.blockedListError);
        }

        if(control.hasError('pattern'))
        {
          if(!isNullOrUndefined(currentTaxIdtypeInfo.taxIdTypeValidationInfo?.errorMessage?.patternError))
          {
            return this.translate.get(currentTaxIdtypeInfo.taxIdTypeValidationInfo?.errorMessage?.patternError);
          }
          else
          {
            return this.translate.get(displayName) + ' ' + this.translate.get('contains invalid characters');
          }
        }
      }
    }
  }


  // Custom Validators
  // Validators For Blocked list
  blockListValidator(blockList: string[]): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      let vatNumber = control.value as string;
      if(vatNumber == null){
        return null;
      }
      if (blockList && blockList.length > 0) {
        return blockList.some(v => vatNumber.includes(v)) ? { blockedNumber: { value: control.value } } : null;
      }

      //  We ignore validation since there isn't a blocklist number
      return null;
    };
  }

  showExistingValue()
  {
    if (this.TaxIdTypeValue?.isNewRecord === false || this.TaxIdTypeValue?.fieldValueExists === true) {
      return true;
    }

    return false;
  }

  editFederalTaxId() {

    //  Change the state of the mask field of tax id to edit mode
    this.TaxIdTypeValue.editModeV2(true, this.taxIdData?.taxIdValue);

    //  Tax ID Type is now required
    this.TaxIdTypeName.enable();
  }

  isFormValid() : Boolean
  {
    this.taxIdTypeChildForm.markAllAsTouched();
    validateAllFormFields(this.taxIdTypeChildForm);
    if(this.taxIdTypeChildForm.valid)
    {
      return true;
    }

    return false;
  }

  getFormData() : AdditionalTaxInfoValue
  {

    if(!isNullOrUndefined(this.TaxIdTypeName?.value) && !isNullOrUndefined(this.TaxIdTypeValue?.fieldControl?.value))
    {
      var additionalTaxInfoValue = new AdditionalTaxInfoValue();
      additionalTaxInfoValue.taxIdType = this.TaxIdTypeName?.value;
      additionalTaxInfoValue.taxIdValue = this.TaxIdTypeValue?.fieldControl?.value;
      additionalTaxInfoValue.isSecure = this.TaxIdList?.filter(x => x.taxIdType == this.TaxIdTypeName?.value)[0]?.isSecure;
      additionalTaxInfoValue.isEncrypted = false;
      additionalTaxInfoValue.last4TaxIdValue = this.TaxIdTypeValue?.fieldControl?.value?.slice(-4);

      console.log(`AdditionalTax Value - ${additionalTaxInfoValue.taxIdType}`, additionalTaxInfoValue);
      return additionalTaxInfoValue;
    }

    return null;
  }

  setData(taxData : AdditionalTaxInfoValue)
  {
    if(isNullOrUndefined(taxData))
    {
      this.TaxIdTypeName.setValue(null, { emitEvent: true });
      this.TaxIdTypeValue.setFieldsV2(taxData, this.permission, null)
      this.TaxIdTypeValue.clearValidators();
    }
    else
    {
      this.TaxIdTypeName.setValue(taxData?.taxIdType, { emitEvent: true });
      this.TaxIdTypeValue.setFieldsV2(taxData, this.permission, null);
    }
  }

  isVisible()
  {
    if(this.isVisibility)
    {
      this.isVisibility = false;
      this.TaxIdTypeReadValue.setValue('****' + this.taxIdData?.last4TaxIdValue);
    }
    else
    {
      this.isVisibility = true;
      this.TaxIdTypeReadValue.setValue(this.taxIdData?.taxIdValue);
    }
  }
}